import { ThemeProvider, ThemeModeProvider } from './theme';
import { PageLayout } from './components/layout/PageLayout';
import { Grid, Title } from './components';
import { Tube } from './components/layout/Tube';
import { GameProvider } from './providers/GameProvider/GameProvider';
import { GuessCount } from './components/GuessCount';
import { GameOver } from './components/GameOver';
import { GDPRAConsentModal } from './components/GDPRConsentModal';

function App() {
  return (
    <ThemeModeProvider>
      <ThemeProvider>
        <GameProvider>
          <PageLayout>
            <Tube align="center" width="auto">
              <Title>LOVE ME DOKU</Title>
              <Grid />
            </Tube>

            <GuessCount />
            <GameOver />
            <GDPRAConsentModal />
          </PageLayout>
        </GameProvider>
      </ThemeProvider>
    </ThemeModeProvider>
  );
}

export default App;
